import React from 'react'
import { CHART_DEBUG } from '../constants'

function shouldDrawLine(item, i) {
  // Do not draw a line if the item is first, the points point is null,
  // or the prior points point is null
  return item.y != null && isNaN(item.y) === false
}

class SparkLine extends React.PureComponent {
  static defaultProps = {
    points: [],
    opacity: 1,
    strokeWidth: 1.5,
    dotSize: 2,
    strokeOpacity: 1,
    clipping: 0,
    pointed: false,
    smooth: false
  }

  state = {
    ready: false
  }

  // Prevent setState from invoking after this component has torn down
  renderable = true

  componentWillUnmount() {
    this.renderable = false
  }

  componentWillMount() {
    import('d3-shape').then(({ line, curveBundle }) => {
      if (this.renderable) {
        this.setState({ ready: true, line, curveBundle })
      }
    })
  }

  getPath() {
    const { points, smooth, scaleX, scaleY } = this.props
    const { ready, line, curveBundle } = this.state

    if (ready !== true) {
      return ''
    }

    const curve = line()

    curve.defined(shouldDrawLine)

    curve.x(dot => scaleX(dot.x))
    curve.y(dot => scaleY(dot.y))

    // Catmull is anchored around data points, where as the bundle
    // provide a smoother curve
    // https://www.npmjs.com/package/d3-shape#curves
    if (smooth) {
      curve.curve(curveBundle.beta(0.9))
    }

    return curve(points)
  }

  renderDot(dot, i) {
    const { scaleX, scaleY, stroke, dotSize } = this.props
    const { ready } = this.state

    return (
      <circle
        key={i}
        cx={scaleX(dot.x)}
        cy={scaleY(dot.y)}
        fill={stroke}
        r={dotSize}
        opacity={ready ? 1 : 0}
      />
    )
  }

  render() {
    const {
      clipping,
      opacity,
      stroke,
      strokeDasharray,
      strokeOpacity,
      strokeWidth,
      label,
      pointed,
      points
    } = this.props

    const path = this.getPath()

    return (
      <g
        className="spark-line"
        opacity={opacity}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeOpacity={strokeOpacity}
        strokeDasharray={strokeDasharray}
      >
        <title>{label}</title>
        {pointed && points.map(this.renderDot, this)}
        <path
          d={path}
          fill="none"
          stroke={CHART_DEBUG ? 'magenta' : 'transparent'}
          strokeWidth={clipping}
        />
        <path d={path} fill="none" />
      </g>
    )
  }
}

export default SparkLine



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/spark-line.js